import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Container, Paper } from '@mui/material';
import { uploadFileToFirebase } from '../../../services/modules/Tenencias'; // Servicio para subir archivos

const RegistrarTenencias = () => {
  const [dpi, setDpi] = useState('');
  const [serie, setSerie] = useState('');
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!dpi || !serie || !file) {
      alert('Por favor, completa todos los campos.');
      return;
    }
    try {
      // Subir el archivo y guardar los datos
      const fileUrl = await uploadFileToFirebase(file, dpi, serie);
      alert(`Tenencia registrada con éxito. URL del archivo: ${fileUrl}`);
    } catch (error) {
      console.error('Error al registrar la tenencia:', error);
      alert('Ocurrió un error al registrar la tenencia.');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ marginTop: '30px' }}>
      <Paper elevation={3} sx={{ padding: '20px' }}>
        <Typography variant="h4" align="center" gutterBottom>
          Registrar Tenencia
        </Typography>
        <Box
          component="form"
          sx={{ display: 'flex', flexDirection: 'column', gap: '15px' }}
          onSubmit={handleSubmit}
        >
          <TextField
            label="DPI del Cliente"
            value={dpi}
            onChange={(e) => setDpi(e.target.value)}
            fullWidth
            required
          />
          <TextField
            label="Número de Serie"
            value={serie}
            onChange={(e) => setSerie(e.target.value)}
            fullWidth
            required
          />
          <Button variant="outlined" component="label">
            Subir Documento de Tenencia
            <input type="file" hidden onChange={handleFileChange} />
          </Button>
          <Button variant="contained" color="primary" type="submit">
            Registrar
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default RegistrarTenencias;
